import { render } from "./TableDialogHeader.vue?vue&type=template&id=c84a2b18&scoped=true"
import script from "./TableDialogHeader.vue?vue&type=script&lang=js"
export * from "./TableDialogHeader.vue?vue&type=script&lang=js"

import "./TableDialogHeader.vue?vue&type=style&index=0&id=c84a2b18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84a2b18"]])

export default __exports__